type ToastType = 'success' | 'error' | 'warning' | 'info';

interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

let toasts: Toast[] = [];
let listeners: (() => void)[] = [];

const notify = () => listeners.forEach(fn => fn());

export function showToast(message: string, type: ToastType = 'info', duration = 4000) {
  const id = Date.now().toString() + Math.random().toString(36).slice(2);
  toasts = [...toasts, { id, message, type }];
  notify();
  if (duration > 0) {
    setTimeout(() => dismissToast(id), duration);
  }
}

export function dismissToast(id: string) {
  toasts = toasts.filter(t => t.id !== id);
  notify();
}

export function getToasts() {
  return toasts;
}

export function subscribeToast(fn: () => void) {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter(l => l !== fn);
  };
}
